import { ComponentType } from '@angular/cdk/overlay';
import { Injector } from '@angular/core';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
// import { FsGalleryDataItem } from '../interfaces/gallery-data-item.interface';
import { RxGalleryPreviewRef } from '../classes/gallery-preview-ref';
import { GalleryPreviewData, PREVIEW_DATA } from './preview-data';

export class RxGalleryPreviewService {
  constructor(
    private _overlay: Overlay,
    private _galleryPreviewComponent: ComponentType<object>,
    private _injector: Injector,
  ) {}

  public open(data: GalleryPreviewData) {
    const overlayRef = this._createOverlay();
    const previewRef = new RxGalleryPreviewRef(overlayRef);

    this.openPortalPreview(this._injector, overlayRef, previewRef, data);

    return previewRef;
  }

  private _createOverlay() {
    const overlayConfig = new OverlayConfig({
      height: '100%',
      width: '100%',
    });
    return this._overlay.create(overlayConfig);
  }

  private openPortalPreview(
    parentInjector: Injector,
    overlayRef: OverlayRef,
    previewRef: RxGalleryPreviewRef,
    data: GalleryPreviewData,
  ) {
    const injector = this._createInjector(parentInjector, previewRef, data);
    const containerPortal = new ComponentPortal(this._galleryPreviewComponent, undefined, injector);
    const containerRef = overlayRef.attach<any>(containerPortal);

    return containerRef.instance;
  }

  private _createInjector(
    parentInjector: Injector,
    previewRef: RxGalleryPreviewRef,
    data: GalleryPreviewData,
  ) {
    const injectionTokens = new WeakMap<any, any>([
      [RxGalleryPreviewRef, previewRef],
      [PREVIEW_DATA, data],
    ]);

    return new PortalInjector(parentInjector, injectionTokens);
  }
}
